module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/GUARDIAN_OF_CROWN_STYLE.7ebf9a4a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/GUARDIAN_OF_CROWN_STYLE.png
// module id = 1290
// module chunks = 16